<template >
  <b-container class="mt-4">
    <h2>Privacy Policy</h2>
    <div class="simple-editor">
      <div class="editor-node" ref="editorNode"></div>
    </div>

    <div>
      <h2>Select Language</h2>
      <b-row>
        <b-col></b-col>

        <b-col>
          <b-form-select v-model="selectedLanguage">
            <option v-for="lang in languages" :key="lang.code" :value="lang">{{ lang.name }}</option>
          </b-form-select>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
    <div class="mt-4">
      <b-row>
        <b-col></b-col>
        <b-col>
          <b-btn variant="primary" @click="savePrivacyPolicy">Save Privacy Policy</b-btn>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
    <div class="mt-4 text-center">
      <b-row v-for="(privacy, index) in getPrivacyPolicy" :key="index">
        <b-card
          border-variant="primary"
          header="Primary"
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
          class="w-100"
        >
          <template v-slot:header>
            <b-row>
              <b-col></b-col>
              <b-col>{{`${privacy.language} Version`}}</b-col>
              <b-col>
                <b-btn @click="editPrivacyPolicy(privacy)" variant="outline-light" size="sm">Edit</b-btn>
              </b-col>
            </b-row>
          </template>
          <b-card-text v-html="privacy.content"></b-card-text>
        </b-card>
      </b-row>
    </div>
  </b-container>
</template>


<script>
import Quill from "quill";
import { languages } from "../../utils/constants";
import { db } from "../../db";
export default {
  props: {
    value: {
      default: "",
      type: String
    }
  },

  data() {
    return {
      languages: languages,
      selectedLanguage: null,
      editorContent: null,
      editorInstance: null,
      editorOpts: {
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }, { align: [] }],
            [{ color: [] }, { background: [] }],
            ["clean"],
            ["link", "image", "video"],
            [{ direction: "rtl" }]
          ]
        },
        theme: "snow"
      },
      updateOperation: false,
      privacyId: null
    };
  },

  watch: {
    value(newVal) {
      // Only update the content if it's changed from an external source
      // or else it'll act weird when you try to type anything
      if (newVal !== this.editorContent) {
        this.editorInstance.pasteHTML(newVal);
      }
    }
  },
  computed: {
    getPrivacyPolicy() {
      return this.$store.getters.getPrivacyPolicy;
    }
  },

  mounted() {
    this.initializeEditor();
  },
  created() {
    this.$store.dispatch("setPrivacyPolicy");
  },

  beforeDestroy() {
    // Turn off all listeners set on text-change
    this.editorInstance.off("text-change");
  },

  methods: {
    initializeEditor() {
      // Set initial content that's going to be picked up by Quill
      this.$refs.editorNode.innerHTML = this.value;
      // Create the Quill instance
      this.editorInstance = new Quill(this.$refs.editorNode, this.editorOpts);
      // Setup handler for whenever things change inside Quill
      this.editorInstance.on("text-change", this.onEditorContentChange);
      // Save any initial content to this.editorContent
      this.setEditorContent();
    },
    onEditorContentChange() {
      // Whenever we change anything, update this.editorContent
      this.setEditorContent();
      // Then emit its value as input so we have a working v-model
      // This $emit will be catched up in the watch:value
      // that's why we guard against calling pasteHTML
      // calling that function while we are typing is undesirable
      this.$emit("input", this.editorContent);
    },
    setEditorContent() {
      this.editorContent = this.editorInstance.getText().trim()
        ? this.editorInstance.root.innerHTML
        : "";
    },
    savePrivacyPolicy() {
      if (
        this.editorContent.trim() !== "" &&
        this.selectedLanguage.name.trim() !== ""
      ) {
        if (!this.updateOperation) {
          db.collection("privacy-policy").add({
            content: this.editorContent,
            language: this.selectedLanguage.name
          });
        } else {
          db.collection("privacy-policy")
            .doc(this.privacyId)
            .update({
              content: this.editorContent,
              language: this.selectedLanguage.name
            });
        }
        this.$store.dispatch("setAboutUs");
        this.resetValues();
      } else {
        alert("Please Add content and Select language ");
      }
    },
    editPrivacyPolicy(privacy) {
      this.privacyId = privacy.id;
      this.editorInstance.pasteHTML(privacy.content);
      this.selectedLanguage = languages.find(language => {
        return (language.name = privacy.language);
      });
      this.updateOperation = true;
    },
    resetValues() {
      this.editorContent = null;
      this.selectedLanguage = null;
      this.updateOperation = false;
    }
  }
};
</script>


<style scoped>
@import "../../assets/quill.snow.css";
</style>